import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { DoctorSocialService } from '../doctor-social/doctor-social.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PostDetailsPopUpComponent } from '../doctor-social/post-details-pop-up/post-details-pop-up.component';
import { getLinkPreview } from "link-preview-js";
import { LikesListDialogComponent } from '../doctor-social/likes-list-dialog/likes-list-dialog.component';
import { fadeUpAnimation } from '../doctor-social/post-details-pop-up/animations';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserSearchHistoryService } from '../doctor-social/search-history.service';

@Component({
  selector: 'app-my-social-activity',
  templateUrl: './my-social-activity.component.html',
  styleUrls: ['./my-social-activity.component.css'],
  animations: [fadeUpAnimation]
})
export class MySocialActivityComponent implements OnInit, OnDestroy {

  searchInput = new FormControl("")
  Posts: any[] = [];
  Ads;

  form: FormGroup;
  basePathImage: string = environment.imageBaseUrl;

  searchOptions: any[] = [];

  notificationsTap: boolean = false
  totalResultNotifications: number = 0
  notificationsRes;

  selectedButton: "likes" | "comments" | "saved" = "likes"

  totalResult: number = 0

  constructor(
    public app: AppService,
    private router: Router,
    public dialog: MatDialog,
    private service: DoctorSocialService,
    @Inject(DOCUMENT) private document: any,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private clipboard: Clipboard,
    private userHistorySearchService: UserSearchHistoryService,
  ) { }

  ngOnInit(): void {
    this.refreshSearchHistory();
    this.scrollToTop();
    this.app.showLoading();
    this.form = new FormGroup({
      postType: new FormControl(1),
      pageSize: new FormControl(5),
      pageNumber: new FormControl(1),
    });
    // this.checkUrlParams();
    this.getAds();
    this.switchBtn('likes')
  }
  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  deleteOptionFromSearchHistory(index){
    this.userHistorySearchService.removeUserSearchHistory(index)
    setTimeout(() => {
      this.searchInput.setValue(null)
      this.refreshSearchHistory();
    }, 100);
  }
  
  refreshSearchHistory(){
    this.searchOptions.length = 0
    setTimeout(() => {
      this.searchOptions = this?.userHistorySearchService?.getUserSearchHistory()
    }, 100);
  }

  ngOnDestroy(): void {

  }

  lastType;
  switchBtn(type) {
    if (type == this.lastType) { return }

    // reset
    this.get("pageSize").setValue(5)
    this.get("pageNumber").setValue(1)
    this.totalResult = 0
    this.Posts.length = 0
    this.scrollToTop();
    // reset

    switch (type) {
      case 'likes': {
        this.getLiked();
        this.lastType = type
        break;
      }
      case 'comments': {
        this.getCommentedPosts();
        this.lastType = type
        break;
      }
      case 'saved': {
        this.getSavedPosts();
        this.lastType = type
        break;
      }
    }
  }

  routeToDocProfile(doc){
    let docObj = {
      fullName: doc?.creatorName,
      speciality: doc?.creatorSpeciality,
      id: doc?.hcpRequestId,
    }
    this.app.routeToDoctorProfile(docObj)
  }

  getLiked = async (): Promise<void> => {
    this.app.showLoading();
    await this.service.likedPosts(this.form.value).subscribe(
      async res => {
        const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
          this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
          if (item?.postMedia) {
            if (item?.postMedia[0]?.mediaType === 3) {
              const transformedItem = await this.urlChangeInput(item);
              return transformedItem;
            }
          }
          return item;
        }));
        this.Posts.push(...processedPosts);
        this.app.dismissLoading();
        this.totalResult = res.data.totalRows;
      }
    )
  }

  getCommentedPosts = async (): Promise<void> => {
    this.app.showLoading();
    await this.service.commentedPosts(this.form.value).subscribe(
      async res => {
        const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
          this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
          if (item?.postMedia) {
            if (item?.postMedia[0]?.mediaType === 3) {
              const transformedItem = await this.urlChangeInput(item);
              return transformedItem;
            }
          }
          return item;
        }));
        this.Posts.push(...processedPosts);
        this.app.dismissLoading();
        this.totalResult = res.data.totalRows;
      }
    )
  }

  getSavedPosts = async (): Promise<void> => {
    this.app.showLoading();
    await this.service.savedPosts(this.form.value).subscribe(
      async res => {
        const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
          this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
          if (item?.postMedia) {
            if (item?.postMedia[0]?.mediaType === 3) {
              const transformedItem = await this.urlChangeInput(item);
              return transformedItem;
            }
          }
          return item;
        }));
        this.Posts.push(...processedPosts);
        this.app.dismissLoading();
        this.totalResult = res.data.totalRows;
      }
    )
  }

  loadMorePosts() {
    let pageSizeNewRes = this.get("pageNumber").value + 1
    // this.get("pageSize").setValue(pageSizeNewRes)
    this.get("pageNumber").setValue(pageSizeNewRes)
    switch (this.lastType) {
      case 'likes': {
        this.getLiked();
        break;
      }
      case 'comments': {
        this.getCommentedPosts();
        break;
      }
      case 'saved': {
        this.getSavedPosts();
        break;
      }
    }
  }

  handleMainSearch() {
    if (this.searchInput.value.length > 0) {
      this.router.navigate([`/${this?.app?.languageCode}/Tebgram/activity`], {
        queryParams: {
          'searchInput': this.searchInput.value,
        }
      });
    }
  }

  notifications() {
    if (!this?.notificationsRes) {
      let PageSize = 20
      let PageNumber = 1
      this.service.getNotifications(PageSize, PageNumber).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.notificationsRes = res?.data?.data
            this.totalResultNotifications = res?.totalRows
          }
        }
      )
    }

    this.notificationsTap == true ? this.notificationsTap = false : this.notificationsTap = true
  }

  getTimeDifferenceString(dateStr: string): string {
    const currentDate = new Date();
    const targetDate = new Date(dateStr);

    const timeDifferenceInMilliseconds = currentDate.getTime() - targetDate.getTime();
    const timeDifferenceInSeconds = Math.floor(timeDifferenceInMilliseconds / 1000);
    const timeDifferenceInMinutes = Math.floor(timeDifferenceInSeconds / 60);
    const timeDifferenceInHours = Math.floor(timeDifferenceInMinutes / 60);
    const timeDifferenceInDays = Math.floor(timeDifferenceInHours / 24);

    if (this.app.languageCode == 'en') {
      if (timeDifferenceInDays > 0) {
        return `${timeDifferenceInDays} day${timeDifferenceInDays > 1 ? 's' : ''} ago`;
      } else if (timeDifferenceInHours > 0) {
        return `${timeDifferenceInHours} hour${timeDifferenceInHours > 1 ? 's' : ''} ago`;
      } else if (timeDifferenceInMinutes > 0) {
        return `${timeDifferenceInMinutes} minute${timeDifferenceInMinutes > 1 ? 's' : ''} ago`;
      } else {
        return 'Just now';
      }
    } else {
      if (timeDifferenceInDays > 0) {
        return `قبل ${timeDifferenceInDays > 1 ? timeDifferenceInDays : ''} ${timeDifferenceInDays > 1 ? 'ايام' : 'يوم'}`;
      } else if (timeDifferenceInHours > 0) {
        return `قبل ${timeDifferenceInHours > 1 ? timeDifferenceInHours : ''} ${timeDifferenceInHours > 1 ? 'ساعات' : 'ساعة'}`;
      } else if (timeDifferenceInMinutes > 0) {
        return `قبل ${timeDifferenceInMinutes > 1 ? timeDifferenceInMinutes : ''} ${timeDifferenceInMinutes > 1 ? 'دقائق' : 'دقيقة'}`;
      } else {
        return 'الآن';
      }
    }

  }

  postDetailsPopUp(id, index) {
    const dialogRef = this.dialog.open(PostDetailsPopUpComponent, {
      width: '100%',
      data: { id, index },
      panelClass: 'custom-modalBox',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == "delete") {
        this.Posts = this.Posts.filter(item => item?.postId !== id);
      } else if (res == "edit") {
        this.service.getPostById(id).subscribe(
          res => {
            if (res.errorCode == 0) {
              let obj = res?.data
              const index = this.Posts.findIndex(item => item?.postId == id);
              if (index != -1) {
                this.Posts[index] = obj
              }
              this.postDetailsPopUp(id, null)
            }
          }
        )
      } else if (res == "like") {
        if (this.selectedButton == 'likes') {
          const index = this.Posts.findIndex(item => item?.postId == id);
          this.Posts.splice(index, 1);
          this.totalResult = this.totalResult - 1
        } else if (this.selectedButton == 'comments') {
          this.service.getPostById(id).subscribe(
            res => {
              if (res.errorCode == 0) {
                let obj = res?.data
                const index = this.Posts.findIndex(item => item?.postId == id);
                if (index != -1) {
                  this.Posts[index] = obj
                }
              }
            }
          )
        }
      } else if (res == "saved") {
        if (this.selectedButton == 'saved') {
          const index = this.Posts.findIndex(item => item?.postId == id);
          this.Posts.splice(index, 1);
          this.totalResult = this.totalResult - 1
        }
      }
    });

  }

  async urlChangeInput(item) {
    try {
      const itemData = item
      const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
      if (urlPattern.test(itemData?.postMedia[0]?.mediaFilePath)) {
        await this.service.getLinkPreviewData(itemData?.postMedia[0]?.mediaFilePath).subscribe(
          res => {
            let modifiedData = {
              mediaFilePath: itemData?.postMedia[0]?.mediaFilePath,
              mediaType: itemData?.postMedia[0]?.mediaType,
              mimeType: itemData?.postMedia[0]?.mimeType,
              urlTitle: res?.title,
              urlImage: res?.image,
              urlDescription: res?.description
            }
            itemData.postMedia[0] = modifiedData
          }
        )
      }
      return itemData
    } catch (error) {
      console.error('An error occurred:', error);
      return item
    }
  }

  urlClicked(url) {
    window.open(url)
  }

  likesPopUp(id, likeCount, type) {
    if (likeCount == 0) { return }
    let req = {
      id: id,
      type: type,
    }
    const dialogRef = this.dialog.open(LikesListDialogComponent, {
      width: '470px',
      data: req
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  likeDislikePost(postId, likeStatus, index) {
    if (likeStatus == false) {
      this.service.likePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.Posts[index].likesCount = this.Posts[index].likesCount + 1
            this.Posts[index].iLikedPost = true
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (likeStatus == true) {
      this.service.unlikePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {

            // this.Posts[index].likesCount = this.Posts[index].likesCount - 1
            // this.Posts[index].iLikedPost = false
            this.Posts.splice(index, 1);
            this.totalResult = this.totalResult - 1

          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  savePost(status, postId, index) {
    if (!status) {
      this.service.savePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Saved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم الحفظ");
            }
            this.Posts.splice(index, 1);
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (status) {
      this.service.unSavePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Unsaved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم إلغاء الحفظ");
            }
            this.Posts.splice(index, 1);
            this.totalResult = this.totalResult - 1
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  copyLink(id) {
    let req = {
      "dynamicLinkInfo": {
        "domainUriPrefix": `https://ihospitalapp.page.link`,
        "link": `https://www.ihospitalapp.com/en/Tebgram/post/${id}`,
        "androidInfo": {
          "androidPackageName": "com.technzone.ihospital"
        },
        "iosInfo": {
          "iosBundleId": "com.technzone.ihospitalapp"
        }
      }
    }
    this.service.createDynamicLink(req).subscribe(
      res => {
        let link = res?.shortLink
        this.clipboard.copy(link);
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Link Copied");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("تم نسخ الرابط");
        }
      }
    )
  }

  getAds() {
    this.service.getAds(30, 1).subscribe(
      res => {
        this.Ads = res.data.data
      }
    )
  }


}
